import Cell from "./WorkCenterTableCell";
import Operation from "./Operation";
export default class Row {
    constructor(row) {
        this.type = row.type;
        this.cells = Array.isArray(row.cells) ? row.cells : [];
        this.object = row.object;
        this.style = row.style
    }

    setCells(cells) {
        this.cells = cells;
    }

    static getRows(orders, headers, workCenterId, preperation) {
        const rows = [];
        orders.forEach(order => {
            rows.push(Row.getOrderRow(order, headers, workCenterId, preperation));
            if (order.showProducts) {
                for (const product of order.products) {
                    rows.push(Row.getProductRow(product, headers, order, workCenterId, preperation));
                }
            }
        });
        return rows;
    }

    static getOrderRow(order, headers, workCenterId, preperation) {
        const row = new Row({ type: "order", object: order });
        const orderSymbol = order.showProducts ? "-" : "+";
        const cells = [];
        headers.forEach(header => {
            if (header.value == "name") {
                cells.push(new Cell({
                    number: 0,
                    text: `${orderSymbol} ${order.toString()}`,
                    style: {
                        "name-cell": true
                    }
                }));
            }
            if (header.value == "customer") {
                cells.push(new Cell({
                    number: 1,
                    text: order.customer.toString()
                }))
            }
            if (header.value == "products_count") {
                cells.push(new Cell({
                    number: 2,
                    text: order.getWorkCenterProductsCount(workCenterId),
                    style: {
                        "number-cell": true
                    }
                }))
            }
            if (header.value == "remaining_products_count") {
                let style = Operation.getCenterStyle(order.products, workCenterId);
                style['number-cell'] = true;
                cells.push(new Cell({
                    number: 3,
                    text: order.getRemainingProducts(workCenterId),
                    style: style
                }))
            }
            if (header.value == "products_area") {
                cells.push({
                    number: 4,
                    text: (Math.round(order.area * 100) / 100).toFixed(2),
                    style: {
                        "number-cell": true
                    }
                })
            }
            if (header.value == "time_left") {
                const dateParam = preperation ? "delivery_date" : "completion_date";
                cells.push(new Cell({
                    number: 5,
                    text: order.getDaysUntilDue(dateParam),
                    style: {
                        "number-cell": !preperation ? true : false
                    }
                }));
            }
            if (header.value == "actions") {
                cells.push(new Cell({
                    number: 6,
                    text: "complete"
                }))
            }
        });
        cells.push(
            new Cell({
                number: -1,
                text: "",
                style: {
                    "checkbox-cell": true
                }
            })
        )
        cells.sort((a, b) => {
            return a.number - b.number;
        });
        row.setCells(cells);
        return row;
    }

    static getProductRow(product, headers, order, workCenterId, preperation) {
        const positionProducts = order.products.filter(orderProduct => {
            return product.position == orderProduct.position;
        });
        const productIndex = positionProducts.indexOf(product);
        const indexText = positionProducts.length > 1 ? `#${productIndex + 1}` : "";
        const row = new Row({ type: "product", object: product });
        const cells = [];
        headers.forEach(header => {
            if (header.value == "name") {
                cells.push(new Cell({
                    number: 0,
                    text: `Poz. ${product.position} ${indexText}`,
                    style: {
                        "name-cell": true
                    }
                }));
            }
            if (header.value == "customer") {
                cells.push(new Cell({
                    number: 1,
                    text: `${product.dimensions()} ${product.type}`,
                    style: {
                        "customer-cell": true
                    }
                }))
            }
            if (header.value == "products_count") {
                cells.push(new Cell({
                    number: 2,
                    text: 1,
                    style: {
                        "number-cell": true
                    }
                }));
            }
            if (header.value == "remaining_products_count") {
                const notCompleted = product.operationNotCompleted(workCenterId);
                let style = Operation.getCenterStyle([product], workCenterId);
                style['number-cell'] = notCompleted;
                style['text-cell'] = !notCompleted;
                cells.push(new Cell({
                    number: 3,
                    text: notCompleted ? "1" : "-",
                    style: style
                }))
            }
            if (header.value == "products_area") {
                cells.push({
                    number: 4,
                    text: product.area,
                    style: {
                        "number-cell": true
                    }
                })
            }
            if (header.value == "time_left") {
                const dateParam = preperation ? "delivery_date" : "completion_date";
                cells.push(new Cell({
                    number: 5,
                    text: order.getDaysUntilDue(dateParam),
                    style: {
                        "number-cell": !preperation ? true : false
                    }
                }));
            }
            if (header.value == "actions") {
                cells.push(new Cell({
                    number: 6,
                    text: "complete"
                }))
            }
        })
        cells.push(
            new Cell({
                number: -1,
                text: "",
                style: {
                    "checkbox-cell": true
                }
            })
        )
        cells.sort((a, b) => {
            return a.number - b.number;
        });
        row.setCells(cells);
        return row;
    }

    getType() {
        const object = this.object;
        if (!object) return;
        if ("count" in object) {
            return "order"
        }
        return "product";
    }
}